import { render, staticRenderFns } from "./LunchMenuItem.vue?vue&type=template&id=f9b47882&scoped=true&"
import script from "./LunchMenuItem.vue?vue&type=script&lang=js&"
export * from "./LunchMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuItem.vue?vue&type=style&index=0&id=f9b47882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b47882",
  null
  
)

export default component.exports